import { render } from "./CardPendingOrderList.vue?vue&type=template&id=7af2c657"
import script from "./CardPendingOrderList.vue?vue&type=script&lang=js"
export * from "./CardPendingOrderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__